import { buildGoogleMapsEmbedUrl } from '../utils/location';

/**
 * Props for VenueMapEmbed.
 */
interface VenueMapEmbedProps {
  query: string;
  title: string;
  className?: string;
}

/**
 * Renders a lightweight embedded Google Map iframe for a venue location.
 */
function VenueMapEmbed({ query, title, className }: VenueMapEmbedProps) {
  const mapUrl = buildGoogleMapsEmbedUrl(query);

  return (
    <iframe
      title={title}
      src={mapUrl}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      className={className}
    />
  );
}

export default VenueMapEmbed;
